<template>
    <div class="flexslider-slider">
        <div class="figure-img"></div>
    </div>
</template>
<script>
export default {

}
</script>

<style>

</style>